import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { AppStore } from './hooks/useAppStore';
import reportWebVitals from './reportWebVitals';
import './assets/scss/style.scss';
import 'antd/dist/antd.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

ReactDOM.render(
  <React.StrictMode>
    <AppStore.Provider>
      <App />
    </AppStore.Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
